import React from "react";
import { useLanguage } from "../components/Language.js";

const BadgesTab = () => {

  const {language} = useLanguage();
  
  return (
    <div>
      {language === "en" ? (
        <>
          <h2>Earning Badges</h2>

          <h4>What are badges?</h4>
          <p>In the Gaelic Connect app, badges are levels of achievement that you can earn as you use the app. You can unlock different 
            achievement badges based on how often you use the app, and how much you engage with Gaelic in your Glasgow community.</p>

          <h4>What different badges can I achieve?</h4>
          <p>There are four levels of badges in the Gaelic Connect app:</p>
          <ul>
            <li>Chiad Cheuman (First Steps)</li>
            <li>Umha (Bronze)</li>
            <li>Airgid (Silver)</li>
            <li>Òr (Gold)</li>
          </ul>

          <p>The more you use the app, the faster you can move up to Òr!</p>

          <h4>How does the badge system work?</h4>

          <p>You can earn points for reporting yourself using Gaelic or engaging with Glasgow’s Gaelic community in various ways, such as:</p>

          <ul>
            <li>Daily log in (10)</li>
            <li>Leaving comments on events (20)</li>
            <li>Liking events (20)</li>
            <li>Attending events (40)</li>
            <li>Creating your own Gaelic events! (50)</li>
          </ul>

          <p>After you earn 250 points, you will move up to the bronze badge. Earning another 500 
            points will move you up to the silver badge, and another 750 points after that will move 
            you up to the gold badge. Use the app regularly for maximum achievement!
          </p>

          <h4>Why did we include badges?</h4>
          <p>We hope that the badge system will make it more fun and engaging for you to use the app, and that it will encourage you to develop and 
            improve your Gaelic language skills through attending more Gaelic events in Glasgow! Badges are intended to give you a sense of achievement 
            and progression as you build your own Gaelic community.</p>

          <p>However, badges are optional – you can use the app without them if you would prefer.</p>


 
        </>
      ) : (
        <>
          <h2>Cosnadh Bràistean</h2>

          <h4>Dè th’ ann am bràistean?</h4>
          <p>Ann an app Ceangal Gàidhlig, tha bràistean mar ìrean coileanaidh as urrainn dhut a chosnadh mar a bhios tu a’ cleachdadh an app. Faodaidh tu diofar 
            bhràistean coileanaidh fhosgladh stèidhichte air cho tric ’s a chleachdas tu an app, agus an ìre gu bheil thu a’ com-pàirteachadh ann an Gàidhlig 
            nad choimhearsnachd ann an Glaschu. </p>

          <h4>Dè na diofar bhràistean as urrainn dhomh a chosnadh?</h4>
          <p>Tha ceithir ìrean de bhràistean ann an app Ceangal Gàidhlig:</p>
          <ul>
            <li>Chiad Cheuman</li>
            <li>Umha</li>
            <li>Airgid</li>
            <li>Òr</li>
          </ul>

          <p>Mar as motha a chleachdas tu an app, ’s ann as luaithe a ghluaiseas tu suas gu Òr!</p>

          <h4>Ciamar a tha an siostam bhràistean ag obrachadh?</h4>

          <p>Faodaidh tu puingean a chosnadh airson thu fhèin aithris a’ cleachdadh Gàidhlig no com-pàirteachadh ann an coimhearsnachd Ghàidhlig Ghlaschu ann an diofar dhòighean, leithid: </p>

          <ul>
            <li>Log a-steach làitheil (10)</li>
            <li>A’ fàgail bheachdan air tachartasan (20)</li>
            <li>A’ cleachdadh a’ phutan ‘Is toigh leam seo’ air tachartasan (20)</li>
            <li>A 'frithealadh thachartasan (40)</li>
            <li>Cruthachadh do thachartasan Gàidhlig fhèin! (50)</li>
          </ul>

          <p>Às deidh dhut 250 puingean a chosnadh, gluaisidh tu suas chun bhràiste umha. Coisinn 500 eile puingean agus 
            gluaisidh tu suas chun bhràiste airgid, agus gluaisidh 750 puing eile às deidh sin suas chun bhràiste òir thu. 
            Cleachd an app gu cunbhalach airson a’ choileanaidh as àirde!
          </p>

          <h4>Carson a tha sinn a’ cleachdadh bhràistean?</h4>

          <p>Tha sinn an dòchas gun dèan an siostam bhràistean e nas spòrsaile agus nas tarraingiche an app a chleachdadh, agus gum 
            brosnaich e thu gu do sgilean Gàidhlig a leasachadh agus a chur am feabhas, tro fhrithealadh barrachd thachartasan Gàidhlig 
            ann an Glaschu! Tha bràistean airson faireachdainn math de choileanadh agus de dh’adhartas a thoirt dhut fhad ’s a tha thu a’ 
            togail do choimhearsnachd Ghàidhlig fhèin. </p>

          <p>Ach, tha bràistean roghainneil – faodaidh tu an app a chleachdadh às an aonais, mas e sin do roghainn.</p>
        </>
      )}
    </div>
  );
};

export default BadgesTab;
